import styled from 'styled-components';

import Button from '~/src/features/_layout/Header/desktop/components/MainMenuItem/components/Button';
import Title from '~/src/features/_layout/Header/desktop/components/MainMenuItem/components/Title';

export const ItemWrapper = styled.div<{ isCurrent: boolean }>`
    flex-direction: column;
    max-width: 245px;
    pointer-events: ${p => p.isCurrent ? 'none' : 'auto'};
`;

export const ItemTitle = styled(Title)`
    margin-bottom: 4px;
`;

export const ItemBtn = styled(Button)`
    margin-top: 12px;
`;
